import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { VENDORS } from "./apiRoutes";

interface UseGetVendorByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getVendorById = async (id: string) =>
  await axiosAuth.get(`${VENDORS}/${id}`);

const useGetVendorById = ({
  id,
  queryParams,
}: UseGetVendorByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["vendor", id],
    queryFn: () => getVendorById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetVendorById;
